module.exports = __webpack_public_path__ + "img/red_007.86d39376.png";